module.exports = __webpack_public_path__ + "static/media/female_new.9c7b5406.jpg";